import { useSearchParams } from "react-router-dom";
import { useGetFormByResponseQuery } from "@/redux/reducer/feedback.api";

const useFormLanguage = (): number => {
  const [searchParams] = useSearchParams();
  const responseId = searchParams.get("id") || "";
  const tenantId = searchParams.get("tid") || "";
  const language = searchParams.get("lang") || "";

  const { formLanguage } = useGetFormByResponseQuery(
    { responseId, tenantId, language },
    {
      skip: !responseId || !tenantId,
      selectFromResult: ({ data }) => ({ formLanguage: data?.languageId || 1 }),
    }
  );

  return formLanguage;
};

export default useFormLanguage;
